import Landing2 from './views/Landing2'
import SellerLogin from './views/SellerLogin'
import Landing from './views/Landing'
import ProductionStandards from './views/ProductionStandards'
import Glossary from './views/Glossary'
import Process from './views/Process'
import AsSeenIn from './views/AsSeenIn'
import FAQ from './views/FAQ'
import Brands from './views/Brands'
import Story from './views/Story'
import Brand from './views/Brand'
import Product from './views/Product'
import Products from './views/Products'
import Category from './views/Category'
import Login from './views/Login'
import SellerExpectations from './views/SellerExpectations'
import SellWithUs from './views/SellWithUs'
import PrivacyPol from './views/PrivacyPol'
import TOU from './views/TOU'
import ShipAndReturn from './views/ShipAndReturn'
import Contact from './views/Contact'
import OurTeam from './views/OurTeam'
import ThankYou from './views/ThankYou'
import Confirmation from './views/Confirmation'
import Payment from './views/Payment'
import ShippingInfo from './views/ShippingInfo'
import Cart from './views/Cart'
import Home from './views/Home'

// Define routes(pages)
export const routes = [
	{
		title: 'Home',
		path: '/',
		component: Home,
		exact: true
	},
	{
		title: 'Your Cart',
		path: '/shopping-cart',
		component: Cart
	},
	{
		title: 'Shipping',
		path: '/shipping',
		component: ShippingInfo
	},
	{
		title: 'Payment',
		path: '/payment',
		component: Payment
	},
	{
		title: 'Confirmation',
		path: '/confirmation',
		component: Confirmation
	},
	{
		title: 'Thank You',
		path: '/thank-you',
		component: ThankYou
	},
	{
		title: 'Our Team',
		path: '/about-us/our-team',
		component: OurTeam
	},
	{
		title: 'Contact Us',
		path: '/about-us/contact-us',
		component: Contact
	},
	{
		title: 'Shipping & Returns',
		path: '/shipping-and-returns',
		component: ShipAndReturn
	},
	{
		title: 'Terms of Use',
		path: '/terms-of-use',
		component: TOU
	},
	{
		title: 'Privacy Policy',
		path: '/privacy-policy',
		component: PrivacyPol
	},
	{
		title: 'Sell With Us',
		path: '/sell-with-us',
		component: SellWithUs
	},
	{
		title: 'Seller Expectations',
		path: '/seller-expectations',
		component: SellerExpectations
	},
	{
		title: 'User Login',
		path: '/login',
		component: Login,
		exact: true
	},
	{
		title: 'Seller Login',
		path: '/login/seller',
		component: SellerLogin
	},
	{
		title: 'Category',
		path: '/category',
		component: Category,
		exact: true
	},
	{
		title: 'Subcategory',
		path: '/category/subcategory',
		component: Products,
		exact: true
	},
	{
		title: 'Product',
		path: '/category/subcategory/product',
		component: Product,
		exact: true
	},
	{
		title: 'Brand',
		path: '/brand-directory/brand',
		component: Brand
	},
	{
		title: 'Brands',
		path: '/brand-directory',
		component: Brands,
		exact: true
	},
	{
		title: 'Our Story',
		path: '/about-us/our-story',
		component: Story
	},
	{
		title: 'FAQs',
		path: '/about-us/faqs',
		component: FAQ
	},
	{
		title: 'As Seen In',
		path: '/as-seen-in',
		component: AsSeenIn
	},
	{
		title: 'Process',
		path: '/about-us/our-process',
		component: Process
	},
	{
		title: 'Glossary',
		path: '/ethical-glossary',
		component: Glossary
	},
	{
		title: 'Production Standards',
		path: '/ethical-production-standards',
		component: ProductionStandards
	},
	{
		title: 'Landing Page',
		path: '/landing-page',
		component: Landing
	},
	{
		title: 'Landing Page 2',
		path: '/landing-page-2',
		component: Landing2
	}
]

export default routes
